module.exports = __webpack_public_path__ + "img/personal-icon.240125cb.svg";